module.exports = __webpack_public_path__ + "img/20.e865b3a5.jpg";